export class EligibilityCriteriaApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getEligibilityCriteria(params) {
    return this.#http.get('/api/eligibility-criteria', { params });
  }

  async createEligibilityCriteria(body) {
    return this.#http.post('/api/eligibility-criteria', body);
  }

  async editEligibilityCriteria({ criteriaId, ...body }) {
    return this.#http.put(`/api/eligibility-criteria/${criteriaId}`, body);
  }

  async deleteEligibilityCriteria({ criteriaId }) {
    return this.#http.delete(`/api/eligibility-criteria/${criteriaId}`);
  }
}
